import { ReactNode } from 'react';

import { RBACCapabilities, useRBAC } from '../../hooks/useRBAC';
import AccessDeniedPage from './AccessDeniedPage';

export type PageCapability = Exclude<keyof RBACCapabilities, 'hasElevatedRole'>;

interface RequireCapabilityProps {
  capability: PageCapability;
  children: ReactNode;
}

/**
 * Prevents role-ineligible pages from being opened by direct URL.
 * Backend authorization remains authoritative for records and mutations.
 */
function RequireCapability({ capability, children }: RequireCapabilityProps) {
  const { capabilities, isLoading } = useRBAC();

  // Application Status depends on a read-only application-state request. Do
  // not redirect a permitted deep link while that capability is still loading.
  if (isLoading) {
    return null;
  }

  if (!capabilities[capability]) {
    return <AccessDeniedPage />;
  }

  return <>{children}</>;
}

export default RequireCapability;
